import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import {
  ActionSheetButton,
  IonActionSheet,
  IonButton,
  isPlatform,
} from '@ionic/react'

import { UGC } from '@/components/atoms/assets/UGC'

import { Tracking, TrackingEvent } from '@/lib/tracking'
import { Routes } from '@/router/routes'
import { isNative } from '@/utils/utils'

import { ugcComposer } from '@/plugins/ugc-composer'

export const UGCButton: FC = () => {
  const [showReportActionSheet, setShowReportActionSheet] = useState(false)
  const history = useHistory()
  const { t } = useTranslation('common')

  const actionSheetButtons = (): ActionSheetButton[] => {
    return [
      {
        text: t('UGC.action.postCreate'),
        handler: async () => {
          if (!isNative()) {
            history.push(Routes.POST)
            return
          }
          const result = await ugcComposer()
          if (result?.media?.url) {
            history.push({
              pathname: Routes.POST,
              state: {
                media: {
                  url: result?.media?.url,
                  ratio: result?.media?.ratio,
                  mimeType: result?.media?.mimeType,
                },
              },
            })
          }
        },
      },
      {
        text: t('UGC.action.conversationCreate'),
        handler: async () => {
          if (!isNative()) {
            history.push(Routes.CONVERSATION_CREATE)
            return
          }
          const result = await ugcComposer()
          if (result?.media?.url) {
            history.push({
              pathname: Routes.CONVERSATION_CREATE,
              state: {
                media: {
                  url: result?.media?.url,
                  ratio: result?.media?.ratio,
                  mimeType: result?.media?.mimeType,
                },
              },
            })
          }
        },
      },
    ]
  }

  return (
    <>
      <IonButton
        className="large"
        color="plain"
        onClick={async (e) => {
          Tracking.triggerEvent(TrackingEvent.AddContentStarted)
          e.stopPropagation()
          if (isNative()) {
            const result = await ugcComposer()
            if (result?.media?.url) {
              history.push({
                pathname:
                  `/${result?.contentType}` || Routes.CONVERSATION_CREATE,
                state: {
                  media: {
                    url: result?.media?.url,
                    ratio: result?.media?.ratio,
                    mimeType: result?.media?.mimeType,
                    mediaType: result?.media?.mediaType,
                  },
                },
              })
            }
            return
          }
          setShowReportActionSheet(true)
        }}
      >
        <UGC className="min-w-[3.5rem]" />
      </IonButton>
      <IonActionSheet
        isOpen={showReportActionSheet}
        mode={isPlatform('ios') ? 'ios' : 'md'}
        onDidDismiss={() => setShowReportActionSheet(false)}
        buttons={actionSheetButtons()}
      />
    </>
  )
}
